import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import EntryPoint from 'Engine/EntryPoint';
import { mainGoldFont } from '../fontStyles';
import { shadowText } from 'Engine/utils/fontStyles';
import { makeHitArea } from 'Engine/utils/makeHitArea';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../enums/eSounds';
import UiAdapter from '../ui/uiAdapterExtended';
import { uiConfig } from '../ui/config';

export default class StartScreenContainer extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    this.onKeyDown = this.onKeyDown.bind(this);

    this.init();
    this.addListeners();
  }


  onResize(data) {
    if (data.isLandscape) {

      this.content.visible = true;
      this.portretContent.visible = false;
      this.startButton.pivot.x = 0;
      this.startButton.x = this.startButton.displayData.x;
      this.startButton.scale.set(this.startButton.displayData.scaleX);
      this.startButton.y = this.startButton.displayData.y;

    } else if (data.isMobile && data.isPortrait) {
      this.content.visible = false;
      this.portretContent.visible = true;
      this.startButton.pivot.x = this.startButton.displayData.width / 2;
      this.startButton.x = this.startButton.displayData.x + this.startButton.displayData.width / 2;
      this.startButton.scale.set(1.25);
      this.startButton.y = 1214;
    }
  }

  init() {
    this.content = this.getChildByName('content');
    this.portretContent = this.getChildByName('portretContent');
    this.overlay = this.getChildByName('overlay');
    this.overlay.alphaValue = 0.9;
    this.overlay.changeColor(0x130b03);
    this.visible = false;
    this.eventMode = 'static';
    this.startButton = this.getChildByName('startButton');
    makeHitArea(this.startButton);
    this.setTextsStyle();
    this.setWinAmounts();

  }

  addListeners() {
    GlobalDispatcher.addOnce('startScreen:show', this.show.bind(this));
    this.startButton.on('pointertap', this.hide, this);
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.onResize,
      this
    );
  }

  setTextsStyle() {
    const setFunction = (content) => {
      [
        content.getChildByName(`start_screen_0`),
        content.getChildByName(`start_screen_3`),
        content.getChildByName(`start_screen_4`),
        content.getChildByName(`start_screen_5`)
      ].forEach(el => el.style = { ...el.style, ...mainGoldFont });
    };

    const startButtonText = this.startButton.getChildByName('start_screen_play');
    startButtonText.style = { ...startButtonText.style, ...shadowText };
    setFunction(this.content);
    if (EntryPoint.mobile) setFunction(this.portretContent);
  }

  setWinAmounts() {
    // const setFunction = (content) => {
    //   const maxWinField = content.getChildByName(`start_screen_max_win_amount`);
    //   // maxWinField.text = MoneyFormat.format(EntryPoint.GameModel.jackpotMaxWin, false);
    // };
    // setFunction(this.content);
    // if (EntryPoint.mobile) setFunction(this.portretContent);
  }

  onKeyDown(event) {
    if (event.keyCode === 32) {
      event.preventDefault();
      event.stopPropagation();
      this.hide();
    }
  }

  show() {
    document.addEventListener('keydown', this.onKeyDown);
    this.startButton.enabled = true;
    this.visible = true;
  }

  hide() {
    this.visible = false;
    this.startButton.enabled = false;
    GlobalDispatcher.dispatch('startScreen:hide');
    if (EntryPoint.GameModel.isFreeSpinsMode) {
      SoundManager.play(eSounds.EST_BACKGROUND_BONUS.soundName, eSounds.EST_BACKGROUND_BONUS.volume, true, eSounds.EST_BACKGROUND_BONUS.group);
    } else {
      SoundManager.play(eSounds.EST_BACKGROUND.soundName, eSounds.EST_BACKGROUND.volume, true, eSounds.EST_BACKGROUND.group);
    }
    document.removeEventListener('keydown', this.onKeyDown);
    OPWrapperService.freeBetsController.show();

    const ControllerUi = window.OPWrapperService.initUi(uiConfig);
    new UiAdapter(ControllerUi).init({ bonusLabelText: 'RESPINS' });
  }
}
